<template>
  <div class='mt-1'>
    <b-modal
      ref='suggestion-for-improvement'
      id='suggestion-for-improvement'
      hide-footer
      header-bg-variant='info'
      header-text-variant='light'
      size='xl'
      @show='showModal()'
      :no-close-on-esc='loading'
      title="Sugestão de melhoria"
      :no-close-on-backdrop='loading'
    >
      <b-overlay
        :show='loading'
        rounded
        opacity='0.6'
        spinner-small
        spinner-variant='primary'
        class='d-inline-block w-100'
        style='min-height: 150px'
      >
        <section class="modal-font-family">
          <section>
            <p class="message-title">
              O HO Fácil Web é um sistema colaborativo que reúne informações da internet e dos arquivos anexados pelos
              usuários,
              oferecendo exatamente o que precisam para fundamentar seus documentos. Entre as fontes consultadas estão
              <a href="https://chemicalsafety.ilo.org/" target="_blank">ILO Chemical Safety</a>,
              <a href="https://pubchem.ncbi.nlm.nih.gov/" target="_blank"> PubChem</a>,
              <a href="https://www.cdc.gov/niosh/" target="_blank"> CDC/NIOSH</a>,
              <a href="https://gestis-database.dguv.de/" target="_blank"> GESTIS</a>,
              entre outras.
            </p>

            <p class="message-title">
              Sua sugestão será repassada à equipe técnica do HO Fácil Web.
            </p>
          </section>

          <section v-if="legalSearch">
            <section>
              <label class="label">CAS: Agente</label>
              <section class="form-control">
                {{ model.getsearchId(legalSearch) }}
              </section>
            </section>


            <section class="mt-4">
              <label class="label">Limites (referência)</label><br />
              <span class="title-ul">Informações atuais:</span>
              <ul style="text-align: left" class="limits ml-3">
                <li>
                  <strong>8h ou TWA: </strong>
                  <span class="">{{ getInformationTwa(legalSearch) }}</span>
                </li>
                <li>
                  <strong>15 min ou STEL: </strong>
                  <span class="">{{ getInformationStel(legalSearch) }}</span>
                </li>
              </ul>
              <b-form-textarea
                v-model="v$.suggestedImprovement.limits.$model"
                rows="3"
                placeholder="Descreva aqui sua sugestão de melhoria"
              >
              </b-form-textarea>
            </section>

            <section class="mt-4">
              <label class="label">Relevância toxicológica (referência)</label><br />
              <span class="title-ul">Informações atuais:</span>
              <ul style="text-align: left" class="limits ml-3">
                <li>
                  <strong>ACGIH: </strong>
                  <span class="">{{ formatNotationsBaseDoTlv(legalSearch) }}</span>
                </li>
                <!--<li>
                  <strong>GESTIS: </strong>
                  <span class="">{{ formatNotations(model.getValue('notations', legalSearch)) }}</span>
                </li>-->
              </ul>
              <b-form-textarea
                v-model="v$.suggestedImprovement.toxicologicalRelevance.$model"
                rows="3"
                placeholder="Descreva aqui sua sugestão de melhoria"
              >
              </b-form-textarea>
            </section>
          </section>

          <section>
            <b-alert
              class="mt-4"
              show
              variant='danger'
              :class='{ hidden: !errors }'
            >
              {{ errors }}
            </b-alert>
          </section>

          <section class='d-flex justify-content-between mt-4'>
            <base-button
              class='w-50 mr-3 btn-cancel'
              @click='closeModal()'
            >
              <span>Cancelar</span>
            </base-button>

            <b-overlay
              :show='loading'
              rounded
              opacity='0.6'
              spinner-small
              spinner-variant='primary'
              class='d-inline-block w-50'
            >
              <base-button
                @click="sendSuggestedImprovement()"
                class='w-100 btn-add d-flex align-items-center justify-content-center'
              >
                <span class='mr-2'>Enviar sugestões </span>
              </base-button>
            </b-overlay>
          </section>
        </section>

        <template v-slot:overlay>
          <div class='text-center loading-spinner'>
            <b-spinner
              style='width: 2rem; height: 2rem'
              variant='primary'
              label='Large Spinner'
            ></b-spinner>
            <h6 class='text-primary'>Enviando sugestões...</h6>
          </div>
        </template>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Acigh from '@/models/Acgih'
import useVuelidate from '@vuelidate/core'
import { required } from '@/utils/validators'

export default {
  name: 'SuggestionForImprovement',
  setup() {
    return { v$: useVuelidate() }
  },
  components: {},
  props: {
    legalSearch: {
      type: Object,
      required: false,
      default: null
    }
  },
  validations() {
    return {
      suggestedImprovement: {
        chemicalAgentId: { required },
        userId: { required },
        limits: { required },
        toxicologicalRelevance: { required }
      }
    }
  },
  data() {
    return {
      loading: false,
      model: Acigh,
      suggestedImprovement: {
        chemicalAgentId: null,
        userId: null,
        limits: null,
        tab: null,
        toxicologicalRelevance: null,
        casAgent: null
      }
    }
  },
  async mounted() {
    try {

    } catch (e) {
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/current']
    },
    errors() {
      return this.$store.getters['access/error']
    }
  },
  methods: {
    ...mapActions('suggestedImprovement', {
      handleCreate: 'handleCreate'
    }),

    getInformationTwa(legalSearch) {
      const ltTwa = this.model.getValue('lt_twa', legalSearch)

      return ltTwa && ltTwa != '-'
        ? `${ltTwa} (ACGIH)`
        : '-'
    },

    getInformationStel(legalSearch) {
      const informationStel = []
      const ltStel = this.model.getValue('lt_stel', legalSearch)
      if (ltStel && ltStel != '-') {
        informationStel.push(ltStel)
      }
      const tetoStel = this.model.getValue('teto_stel', legalSearch)
      if (tetoStel && tetoStel != '-') {
        informationStel.push('Teto')
      }
      return informationStel.length > 0
        ? `${informationStel.join(', ')} (ACGIH)`
        : '-'
    },

    formatNotations(text) {
      const replaceBr = new RegExp('<br/>', 'g')
      return text.replace(replaceBr, ' ')
    },

    formatBaseDoTlv(text) {
      const replaceBr = new RegExp('<br/>', 'g')
      return text.replace(replaceBr, ' ')
    },

    formatNotationsBaseDoTlv(legalSearch) {
      const list = []
      const notations = this.model.getValue('notations', legalSearch)
      if (notations && notations != '-') {
        list.push(notations)
      }
      const baseDoTlv = this.model.getValue('base_do_tlv', legalSearch)
      if (baseDoTlv && baseDoTlv != '-') {
        list.push(baseDoTlv)
      }

      const relevance = list.join(' ')
      const replaceBr = new RegExp('<br/>', 'g')
      return relevance ? relevance.replace(replaceBr, ' ') : '-'
    },

    async showModal() {
      try {
        this.suggestedImprovement = {
          chemicalAgentId: this.legalSearch._id,
          userId: this.user.id,
          limits: null,
          tab: 'PreventionistLimits',
          toxicologicalRelevance: null,
          casAgent: null
        }
        this.loading = false
        await this.$store.dispatch('access/updateError', ``)
      } catch (e) {

      }
    },

    async sendSuggestedImprovement() {
      try {
        await this.$store.dispatch('access/updateError', ``)
        let validate = await this.v$.$validate()
        if (!validate) {
          await this.$store.dispatch('access/updateError', `Preencha todos os campos corretamente`)
          this.loading = false
          return
        }

        this.suggestedImprovement.casAgent = this.suggestedImprovement.casAgent = this.model.getsearchId(this.legalSearch)
        this.loading = true
        const { data, status } = await this.handleCreate(this.suggestedImprovement)
        this.loading = false
        let message = data.message
        let variant = 'success'
        if (status !== 201) {
          message = data.errors
          variant = 'danger'
        }
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.closeModal()
      } catch (e) {
        console.log(e)
      }
    },

    closeModal() {
      if (this.loading) {
        return
      }
      this.$bvModal.hide('suggestion-for-improvement')
    }
  },
  created() {
  }
}
</script>
<style lang='scss' scoped>
.btn-cancel {
  background: transparent !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.btn-add {
  background: var(--navy-blue) !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: #ffffff;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.divider {
  height: 1px;
  background: #D9D9D9;
}

.message-title {
  font-weight: 400;
  color: #808080;

  a {
    font-weight: 400;
    color: #808080;
    text-decoration: underline;
  }
}

.label {
  font-weight: 700;
  font-size: 17px;
  color: #262626;
}

.limits {
  font-weight: 400;
  font-size: 15px;
  color: #808080;
}

.title-ul {
  font-weight: 700;
  color: #3F444D;
}
</style>
